import { createConfig } from "@privy-io/wagmi"
import { http as httpTransport } from "wagmi"
import { SOURCE_CHAIN_RPC_URL, sourceChain } from "./source-chain"

export { sourceChain }

export const supportedChains = [sourceChain] as const

export const getWagmiConfig = () => {
  return createConfig({
    chains: supportedChains,
    ssr: true,
    transports: {
      [sourceChain.id]: httpTransport(SOURCE_CHAIN_RPC_URL || undefined),
    },
  })
}
